module.exports = "/_next/static/images/banner_yellowpick_571.9xgQ2TYb.png";